"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiForm = exports.FormStatus = void 0;
const button_1 = require("client/components/material/button");
const alert_1 = require("client/components/ui/alert");
const button_2 = require("client/components/ui/button");
const callable_1 = require("client/components/ui/callable");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const preventDefault_1 = require("client/components/ui/preventDefault");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactCSSTransitionGroup = require("react-addons-css-transition-group");
require("./form.less");
var FormStatus;
(function (FormStatus) {
    FormStatus["Loading"] = "loading";
    FormStatus["Clean"] = "clean";
    FormStatus["Dirty"] = "dirty";
    FormStatus["Saving"] = "saving";
    FormStatus["Saved"] = "saved";
    FormStatus["Error"] = "error";
})(FormStatus = exports.FormStatus || (exports.FormStatus = {}));
class UiForm extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleSubmit = preventDefault_1.preventDefault(() => {
            callable_1.callable(this.props.onSubmit)();
        });
    }
    render() {
        const { buttons = [], className = "", error, warning, loading, title, id } = this.props;
        // const loadingClass = loading ? '' : ''; // #TK added. disable loading icon opacity. fix later.
        // const loadingClass = loading ? " ui-form__loading-bg--loading" : ""; caused loader issue i removed class only 2025-02-01 22:05:00
        const loadingClass = loading ? "" : "";
        const edited = this.props.isChanged ? this.props.isChanged() : false;
        const status = edited ? FormStatus.Dirty : this.props.status;
        const statusClass = status ? `form-status-${status}` : "";
        // console.group("UiForm Logs");
        // console.log("this.props.status", this.props.status);
        // console.log("", this.props.status);
        // console.log("edited", edited);
        // console.log("status", status);
        // console.log("statusClass", statusClass);
        // console.groupEnd();
        return (React.createElement("form", { className: `ui-form ${className} ${statusClass}`, id: id, onSubmit: this.handleSubmit },
            React.createElement(ReactCSSTransitionGroup, { transitionName: "error", transitionEnterTimeout: 500, transitionLeaveTimeout: 500 },
                error && React.createElement(alert_1.UiAlert, { title: "Error", type: "error", message: error }),
                warning && (React.createElement(alert_1.UiAlert, { title: "Warning", type: "warning", message: warning }))),
            title && React.createElement("div", { className: "ui-form__title" }, title),
            React.createElement("div", { className: "ui-form__children" }, this.props.children),
            buttons.length > 0 && (React.createElement("div", { className: "ui-form__buttons" }, buttons.map((child, i) => {
                if (button_1.isMaterialButton(child) || button_2.isUiButton(child)) {
                    return ramda_1.merge(child, { key: i });
                }
                else {
                    return (React.createElement(button_1.MaterialButton, { disabled: this.props.shouldDisableSave, className: this.props.submitClassName
                            ? this.props.submitClassName
                            : "", primary: true, type: "submit", key: i, saving: status === FormStatus.Saving }, child));
                }
            }))),
            React.createElement("div", { className: `ui-form__loading-bg ${loadingClass}` },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "ui-form__loading-indicator" }))));
    }
}
exports.UiForm = UiForm;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/form/form.tsx
// module id = 2124
// module chunks = 0 1 2